<template>
    <div>
        <h1 class="page-title">{{is_room_user ? `My rooms` : `My projects`}}</h1>
        <div class="projects">
           <template v-if="projects_no_loaded">
            <v-card class="mx-auto my-12 grey--background" :loading="true">
            Loading
            </v-card>
           </template>
           <template v-else>
            <v-container fluid>
                <v-row style="min-height: 100px">
                   <v-col cols="6" md="6" lg="4">
                      <v-select v-if="domains_to_select.length > 1" label="Domain" :items="domains_to_select" v-model="domain_id" />
                   </v-col>
                    <v-col cols="6" md="6" lg="4">

                     <div v-if="projects && projects.length" class="project-search">
                         <v-text-field
                                 v-model="myProjectSearchInput"
                                 label="Type project name">
                         </v-text-field>
                     </div>
                    </v-col>
                </v-row>
                <v-row>
                    <!-- There is hidden dialog in NewProjectItem ... :/ -->
                    <v-col class="project__left-side" cols="6" md="6" lg="4">
                        <NewProjectsItem
                                :domain_id="domain_id"
                                v-show="can_create_projects"
                                :isDialogOpened="isDialogOpened"
                                v-on:dialogClosed="closeDialog">
                        </NewProjectsItem>
                        <div v-if="projects && !projects.length" class="projects__content">
                            <h2 class="projects__subtitle">Let’s get started</h2>
                            <p class="projects__paragraph">If you wish to create Projects or a new Room, please contact the Majorelle team who will happily assist you.
                            Thank you!</p>
                        </div>
                    </v-col>
                    <template v-if="projects && projects.length">
                        <v-col v-for="(item) of sortedProjects" :key="item.id" cols="6" md="6" lg="4">
                            <ProjectsItem
                                    v-on:projectUpdated="updateProjects($event)"
                                    class="community__item"
                                    :project="item">
                            </ProjectsItem>
                        </v-col>
                    </template>
                    <v-col v-if="projects && !projects.length" class="project__decoration" md="6">
                        <img alt="Projects" :src="require('@/assets/img/projects.jpg')"/>
                    </v-col>
                </v-row>
            </v-container>
          </template>
        </div>
    </div>
</template>

<script>
    import {store} from "../store/store";
    import axios from "axios";
    import ProjectsItem from "../components/Projects/ProjectsItem";
    import NewProjectsItem from "../components/Projects/NewProjectsItem";
    import {getAvailableDomains, projectCan, isRoomUser} from '../services/project.service';

    export default {
        name: "Projects",
        components: {ProjectsItem, NewProjectsItem},
        data: () => ({
            projects_all: [],
            dialog: null,
            available_domains: [],
            domain_id: 0,
            projects_no_loaded: true,
            myProjectSearchInput: "",
            is_room_user: false,
        }),
        computed: {
            projects: function () {
              // filters projects for given selected domain_id only
              return this.projects_all.filter(p => p.domain_id == this.domain_id);
            },
            projects_matching_search: function () {
              return this.filterProjectsbySearch(this.projects);
            },
            domains_to_select: function () {
                // user can select domain if
                // - can create projects in that domain
                // - there are any projects existing there
                return this.available_domains.filter(d => {
                  if (d.id == 0) { // Domain 0 is ADMIN, and we do not allow projects here
                      return false;
                  }
                  return projectCan('create_project', d.id, "*") ||
                      this.projects_all.filter(p => p.domain_id == d.id).length > 0;
                }).map(d => {
                  return {
                    "text": d.name,
                    "value": d.id,
                  }
                })
            },
            isDialogOpened: function () {
                if (this.$route.params.dialog !== undefined) {
                    return this.$route.params.dialog || this.dialog
                } else if (this.dialog) {
                    return this.dialog
                }
                return this.dialog
            },
            sortedProjects: function () {
                if (this.projects_matching_search) {
                    const tempProjects = Object.assign([], this.projects_matching_search);
                    return tempProjects.sort((a, b) => {
                        const aAccessedAt = Date.parse(a.accessed_at);
                        const bAccessedAt = Date.parse(b.accessed_at);
                        if (a.is_starred === b.is_starred) {
                            return bAccessedAt - aAccessedAt
                        } else {
                            return b.is_starred ? 1 : -1
                        }
                    })
                }
                return this.projects
            },
            can_create_projects: function () {
              return projectCan('create_project', this.domain_id, "*")
            }
        },
        methods: {
            openDialog: function () {
                this.dialog = true;
            },
            closeDialog: function () {
                this.dialog = false;
                this.$router.push({name: "Projects"})
            },
            deleteProject: function (projectId) {
                store.dispatch('getAccessToken').then(token => {
                    axios.delete(`/projects/${projectId}`, {
                        headers: {Authorization: "Bearer " + token}
                    }).then(resp => {
                        this.projects_all = this.projects.filter(item => !(item.id === projectId))
                        return resp
                    })
                }).catch(err => err);
            },
            updateProjects: function ($e) {
                const index = this.projects.map(project => project.id).indexOf($e.id);
                this.projects[index].is_starred = $e.is_starred;
            },
            filterProjectsbySearch(arr) {
                const regEx = new RegExp(this.myProjectSearchInput, 'gi')
                return arr
                    .filter(p => p.name.match(regEx));
            },
        },
        mounted() {
            if (this.$route.path !== '/projects') {
                this.$router.push({name: "Projects"})
            }

            this.is_room_user = isRoomUser();

            store.dispatch('getAccessToken').then(token => {
                    axios.get('/projects',
                        {
                            headers: {Authorization: "Bearer " + token}
                        }).then(resp => {
                        this.projects_all = resp.data.projects
                        this.projects_no_loaded = false;
                    })
                }
            ).catch(err => err);

            getAvailableDomains().then(available_domains => {
              this.available_domains = available_domains;
            });


        },
        watch: {
            $route: {
                handler: function (val, oldVal) {
                    if (oldVal.name === "DeleteProjectConfirmation" && this.$route.params.id !== undefined) {
                        const projectId = this.$route.params.id;
                        this.deleteProject(projectId)
                    }
                },
                deep: true
            },
            domains_to_select: function (val, oldVal) {
              if (val.length > 0) {
                this.domain_id = val[0].value;
              }
              else {
                this.domain_id = null;
              }
            },
        }
    }
</script>

<style scoped>

</style>
